import { AlignJustify, Bell, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Popover from "../../base_component/Popover/Popover";
import { useEffect, useState } from "react";
import { Socket } from "../../Socket/Socket";
import { useRoomManager } from "../../components/RoomManager";
import { getNotificationCountAPI, getNotificationsAPI, getProfileAPI } from "../../service/ApiServices";
import { ThreeDots } from "react-loader-spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import profileImage from "../../assets/images/user.png";
import toast from "react-hot-toast";
import { IoMdNotifications } from "react-icons/io";
import { useProfile } from "../../context/ProfileContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { validateUrl } from "../../base_component/Common/data";

function TopMenu(props) {
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [nodata, setNodata] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const userId = localStorage.getItem("hoast_user_id");
  const { leaveRoom } = useRoomManager();
  const { setProfilePic, profilePic } = useProfile();

  const handleProfileNavigation = () => {
    leaveRoom();
    navigate("/profile");
  };

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
  };

  useEffect(() => {
    if (isImageLoading) {
      const timeout = setTimeout(() => {
        setIsImageLoading(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [isImageLoading]);

  useEffect(() => {
    if (userId) {
      if (!Socket.connected) {
        console.log("Connecting to socket...");
        Socket.connect();
      }

      Socket.on("connect", () => {
        console.log("✅ Connected to socket:", Socket.id);

        Socket.emit("socket_register", {
          user_id: userId,
          token: localStorage.getItem("hoast_token")
        });
      });

      Socket.on("socket_registered", (data) => {
        console.log("📌 Socket registered:", data);
      });
    }

    return () => {
      Socket.off("connect");
      Socket.off("socket_registered");
    };
  }, [userId]);

  useEffect(() => {
    Socket.on("new_notification", (data) => handleCountUpdate(data));

    return () => {
      Socket.off("new_notification", (data) => handleCountUpdate(data));
    };
  }, [Socket]);

  const handleCountUpdate = (data) => {
    console.log(data, "Notification data");
    if (data?.count) {
      setNotificationCount(data?.count);
    }
  };

  const getListNotifications = async (pageNo) => {
    setNodata(true);
    try {
      const res = await getNotificationsAPI({ page: pageNo, limit: 10 });
      const data = res?.data?.data?.notifications || [];
      if (res.status === 200) {
        setNotificationData(prev =>
          pageNo === 1 ? data : [...prev, ...data]
        );
        setPageNo(pageNo);
        setNotificationCount(0);
        setPageCount(res?.data?.total_pages);
      }
    } catch (err) {
      const errorData = err?.response?.data;
      if (err?.response?.status === 401) {
        toast.error(errorData?.errors?.[0]?.msg || "Unauthorized");
        localStorage.clear();
        navigate("/login");
        return;
      }

      const errorMsg = errorData?.errors?.[0]?.msg || errorData?.message || "Something went wrong";
      toast.error(errorMsg);
    } finally {
      setNodata(false);
    }
  };

  const getProfile = () => {
    setIsImageLoading(true);
    getProfileAPI()
      .then((res) => {
        const imageUrl = res?.data?.data?.user?.profile_image;
        const plan = res?.data?.data?.user?.is_plan_active;
        localStorage.setItem("is_free_plan_days", res?.data?.data?.free_tier_days);
        
        if (plan === true) {
          localStorage.setItem("plan", "yes");
          window.dispatchEvent(new Event('planStatusChanged'));
        } else {
          localStorage.setItem("plan", "no");
          window.dispatchEvent(new Event('planStatusChanged'));
        }
        setProfilePic(imageUrl);
        if (!imageUrl) {
          setIsImageLoading(false);
        }
        localStorage.setItem("plan_start_date", res?.data?.data?.user?.plan_start_date);
        localStorage.setItem("plan_end_date", res?.data?.data?.user?.plan_end_date);
      })
      .catch((err) => {
        const message = err?.response?.data?.message;
        if (err?.response?.status === 401) {
          localStorage.removeItem('hoast_token')
          localStorage.removeItem('hoast_refresh_token')
          navigate('/login')
        }
        toast.error(message || "Something went wrong!");
        setIsImageLoading(false);
      });
  }

  const handlegetcounts = () => {
    getNotificationCountAPI()
      .then((res) => {
        setNotificationCount(res?.data?.data?.unread_count);
      })
      .catch((err) => {
        const message = err?.response?.data?.message;
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          localStorage.removeItem('hoast_token')
          localStorage.removeItem('hoast_refresh_token')
          navigate('/login')
        }
        toast.error(message || "Something went wrong!");
      });
  }

  useEffect(() => {
    getProfile();
    handlegetcounts();
  }, []);

  useEffect(() => {
    if (profilePic) {
      setIsImageLoading(true);
    }
  }, [profilePic]);

  const viewMores = () => {
    if (pageNo < pageCount) {
      getListNotifications(pageNo + 1);
      setHasMore(true);
    } else {
      setHasMore(false);
    }
  };

  const handleNotificationClick = (item, close) => {
    props.setSidebarOpen(false);
    if (item.content_type !== "chat_message") {
      return;
    }
    navigate(`/messages`, { state: { id: item.content_id } });
    close();
  }

  return (
    <>
      <header className="z-20 flex w-full bg-white shadow  dark:bg-boxdark h-[80px]">
        <div className="flex flex-grow items-center justify-between lg:justify-between py-4 px-4 md:px-8">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="z-99 block rounded-sm bg-white p-1 lg:hidden"
            >
              <AlignJustify className="rotate-180	" />
            </button>
          </div>

          <div className="flex items-center">
            <Popover className="relative">
              {({ close }) => (
                <>
                  <Popover.Button className="outline-0 relative" onClick={() => { getListNotifications(1); setNotificationData([]); setPageNo(1); setHasMore(true); setNodata(false); }}>
                    <div className="border p-2 rounded-full w-10 h-10 flex justify-center items-center hover:bg-gray-100">
                      <Bell className="text-gray-700" />
                    </div>
                    {notificationCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </span>
                    )}
                  </Popover.Button>

                  <Popover.Panel className="absolute z-10 md:right-0 -right-16 mt-2 bg-white shadow-lg rounded-lg md:w-[400px] w-[300px]">
                    <div className="p-4 flex items-center justify-between border-b">
                      <h2 className="text-xl font-semibold text-[#0F1113]">Notifications</h2>
                      <Popover.Button className="outline-0">
                        <X className="text-gray-500 hover:text-gray-700" />
                      </Popover.Button>
                    </div>
                    <div className="px-5 mt-5 md:max-h-[calc(504px-110px)] max-h-[calc(400px-110px)] overflow-y-auto custom-scrollbar"
                      id="notifyside"
                      style={{
                        msOverflowStyle: "none",
                      }}>
                      <div className="cursor-pointer">
                        <div>
                          {nodata === false &&
                            notificationData?.length <= 0 ? (
                            <div className="flex justify-center items-center mt-5 h-[350px]">
                              <div className="m-auto text-center">
                                <p className="pt-4 text-gray-400 text-sm">No Notification Yet!</p>
                              </div>
                            </div>
                          ) : (
                            <>
                              {notificationData?.map((items, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={`${index === 0 ? "  " : ""} py-3 border-b last:border-none flex items-center w-full justify-self-center cursor-pointer`}
                                    onClick={() => handleNotificationClick(items, close)}
                                  >
                                    <div className="min-w-[42px] min-h-[42px] border border-gray-200 rounded-full flex justify-center items-center relative">
                                      <IoMdNotifications className="md:text-3xl text-2xl text-[#F48B94]" />
                                    </div>
                                    <div className="ps-3">
                                      <h3 className='md:text-base text-sm font-semibold'>{items?.title}</h3>
                                      <p className="m-0 text-black text-sm line-clamp-2 font-medium">
                                        {items?.body || "-"}
                                      </p>
                                      <p className="text-[12px] text-[#ADADAD]">
                                        {moment(items?.created_at).format("lll")}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                        <div className="flex justify-center mt-5">
                          <InfiniteScroll
                            dataLength={notificationData?.length || 0}
                            next={viewMores}
                            hasMore={hasMore}
                            loader={
                              nodata ? (
                                <ThreeDots
                                  width={40}
                                  height={10}
                                  color="#000"
                                  className="m-auto"
                                  wrapperClass="flex justify-center items-center"
                                  ariaLabel="circles-loading"
                                  wrapperStyle={{}}
                                  visible={true}
                                />
                              ) : (
                                ""
                              )
                            }
                            scrollableTarget="notifyside"
                          />
                        </div>
                      </div>
                    </div>
                  </Popover.Panel>
                </>
              )}
            </Popover>

            <div className="cursor-pointer ms-6">
              {isImageLoading && profilePic ? (
                <Skeleton
                  circle
                  width={40}
                  height={40}
                  className="w-10 h-10"
                />
              ) : (
                <img
                  onClick={handleProfileNavigation}
                  src={profilePic ? validateUrl(profilePic) : profileImage}
                  className="w-10 h-10 rounded-full object-cover"
                  alt="profile"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                />
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default TopMenu;
